// utils.ts
export const hexToRgba = (hex: string, alpha: number) => {
  const match = hex.match(/\w\w/g);
  if (!match) {
    console.error(`Invalid hex color value: ${hex}`);
    return hex;
  }
  const [r, g, b] = match.map(x => parseInt(x, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
